import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class MediumActions {
    static SET_SELETED_MEDIUM = '[Medium]: Set Selected Medium';
    static CLEAR_MEDIUM = '[Medium]: Clear Medium';
    static RESET_SELECTED_MEDIUM = '[Medium]: Reset Selected Medium';

    static SET_CARD_TYPE_MASK = '[Medium] Set Card Type Mask';
    static SET_AVAILABLE_MEDIUM_GROUPS = '[Medium] Set Available Medium Groups';
    static SET_SELECTED_MEDIUM_GROUP = '[Medium] Set Selected Medium Group';

    setSelectedMedium(payload): RidangoReduxAction {
        return {
            type: MediumActions.SET_SELETED_MEDIUM,
            payload: payload,
        };
    }

    resetSelectedMedium() {
        return {
            type: MediumActions.RESET_SELECTED_MEDIUM,
        };
    }

    clearMedium(): RidangoReduxAction {
        return {
            type: MediumActions.CLEAR_MEDIUM,
        };
    }

    setCardTypeMask(payload): RidangoReduxAction {
        return {
            type: MediumActions.SET_CARD_TYPE_MASK,
            payload: payload,
        };
    }


    setAvailableMediumGroups(payload): RidangoReduxAction {
        return {
            type: MediumActions.SET_AVAILABLE_MEDIUM_GROUPS,
            payload: payload,
        };
    }

    setSelectedMediumGroup(payload): RidangoReduxAction {
        return {
            type: MediumActions.SET_SELECTED_MEDIUM_GROUP,
            payload: payload,
        };
    }


}
